import {ContentMetrics} from '../analytics/AnalyticsPage';
import {useAnalyticsState} from '../analytics/analyticsState';
import {Link} from 'react-router-dom';
import {ExternalLink} from 'lucide-react';
import {useChannels} from '../../app/context';
import type {Content} from '../../lib/types';
import {PublishingIdentity} from '../../app/PublishingIdentity';
import {PublishedPostPreview} from '../editor/SocialPostPreview';
import {safeWebUrl} from '../editor/SocialPostMedia';
export {PrivateSocialImage,safeWebUrl} from '../editor/SocialPostMedia';

function publicationDate(value?:string){
 return value&&Number.isFinite(Date.parse(value))?new Date(value).toLocaleString('da-DK',{dateStyle:'long',timeStyle:'short',timeZone:'Europe/Copenhagen'}):'Udgivelsestidspunkt ukendt';
}

export function SocialArchive({item,publicationId}:{item:Content;publicationId?:string}){
 const analytics=useAnalyticsState();
 const {channels}=useChannels(),publications=(item.publications||[]).filter(p=>channels.some(c=>c.resource.id===p.resourceId));
 const selected=publicationId?publications.find(p=>p.id===publicationId):publications[0];
 const channel=channels.find(c=>c.resource.id===selected?.resourceId),connection=channel?.connections.find(c=>c.id===selected?.connectionId);
 const providerUrl=safeWebUrl(selected?.providerUrl);
 return <section aria-label="Publiceret opslag" className="panel social-archive">
  {publications.length>1&&<nav className="social-archive-versions" aria-label="Vælg publiceret version">{publications.map(p=>{
   const ch=channels.find(c=>c.resource.id===p.resourceId),conn=ch?.connections.find(c=>c.id===p.connectionId);
   return <Link key={p.id} aria-current={selected?.id===p.id?'page':undefined} to={analytics.link(`/content/${encodeURIComponent(item.id)}?view=archive&publication=${encodeURIComponent(p.id)}`)}><PublishingIdentity connection={conn} channel={ch}/><span>{publicationDate(p.publishedAt)}</span></Link>;
  })}</nav>}
  {!selected?<p>{publicationId?'Dette opslag findes ikke, eller du har ikke længere adgang til det.':'Der er endnu ingen tilgængelige publicerede opslag.'}</p>:<>
   <PublishedPostPreview publication={selected} connection={connection}/>
   {providerUrl&&<a className="text-link actions" href={providerUrl} target="_blank" rel="noreferrer"><span>Åbn opslag på {connection?.platform==='linkedin'?'LinkedIn':connection?.platform==='facebook'?'Facebook':connection?.platform==='instagram'?'Instagram':'platformen'}</span><ExternalLink size={15}/></a>}
  </>}
  {selected&&<ContentMetrics itemId={item.id} publicationId={selected.id} availableOnly/>}
 </section>;
}
